import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
const SkeletonContainer = styled.div`
  padding: ${rem(8)} ${rem(12)};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.default.five};
`

interface Props {
  position?: number
  className?: string
}

function OfferDescriptionLoadingSkeleton({ className }: Props) {
  return (
    <SkeletonContainer className={className}>
      <TextLoadingBox typography="heading6" width="15ch" />
      <TextLoadingBox typography="heading5" width="100%" lines={1} />
    </SkeletonContainer>
  )
}

export default OfferDescriptionLoadingSkeleton
